// extracted by mini-css-extract-plugin
export default {"container":"menu_container__1u2SP","dot":"menu_dot__2h4us","dark":"menu_dark__2fjTI","button":"menu_button__2F2ng","active":"menu_active__3Ob4R"};